// eslint-disable-next-line import/prefer-default-export
export const contactEmail = 'sales@danube.ai';
